import { render } from "./PrimaryNavigationItem.vue?vue&type=template&id=1307da8f"
import script from "./PrimaryNavigationItem.vue?vue&type=script&lang=ts"
export * from "./PrimaryNavigationItem.vue?vue&type=script&lang=ts"
script.render = render

export default script